<template>
  <div
    class="wrapper-scrollbar-container"
    ref="scrollContainer"
    @scroll="onScroll"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "WrapperScrollbarComponent",
  methods: {
    onScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;
      const threshold = 50;
      if (el.scrollHeight - el.scrollTop - el.clientHeight < threshold) {
        this.$emit("scrollingEnd");
      }
    }
  },
  props: {
    height: {}
  }
};
</script>

<style lang="scss" scoped>
.wrapper-scrollbar-container {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 0.5rem;
  -webkit-overflow-scrolling: touch;

  // Custom scrollbar styling
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(49, 53, 92, 0.2);
    border-radius: 3px;
    &:hover {
      background: rgba(49, 53, 92, 0.4);
    }
  }
  // Firefox
  scrollbar-width: thin;
  scrollbar-color: rgba(49, 53, 92, 0.2) transparent;
}
</style>
